<template>
  <div>
    <RegisterDialog
      v-if="wholesalerId && showDialog"
      @emitShow="registrationButtonClose"
      :wholesalerId="wholesalerId"
    />
  </div>
</template>

<script>
import RegisterDialog from '@/components/payments/RegisterDialog.vue'
export default {
  components: {
    RegisterDialog,
  },
  data() {
    return {
      showDialog: true,
      wholesalerId: null,
    }
  },
  created() {
    this.wholesalerId = this.$route.query.wholesalerId
  },
  methods: {
    async registrationButtonClose(result) {
      this.showDialog = result
      await this.$router.push('/')
    },
  },
}
</script>
